@if (IsInSite()) {
  @if (IsButton()) {
    <button
      class="sheyda-icon-button"
      mat-icon-button
      [ariaLabel]="Icon()"
      [routerLink]="Link()"
      (click)="(click)"
      [ngClass]="Appearance()"
      [disabled]="disabled()"
    >
      <ng-container *ngTemplateOutlet="iconButtonData"></ng-container>
    </button>
  } @else {
    <a
      class="sheyda-icon-button"
      mat-icon-button
      [ariaLabel]="Icon()"
      [routerLink]="Link()"
      (click)="(click)"
      [ngClass]="Appearance()"
      [disabled]="disabled()"
    >
      <ng-container *ngTemplateOutlet="iconButtonData"></ng-container>
    </a>
  }
} @else {
  <a
    class="sheyda-icon-button"
    mat-icon-button
    [ariaLabel]="Icon()"
    [href]="Link()"
    (click)="(click)"
    [ngClass]="Appearance()"
    [disabled]="disabled()"
  >
    <ng-container *ngTemplateOutlet="iconButtonData"></ng-container>
  </a>
}

<ng-template #iconButtonData>
  @if (loading()) {
    <app-loading-spinner />
  }
  <mat-icon [fontSet]="IsFillIcon() ? 'mat-symbol-round-fill' : 'mat-symbol-round'">{{ Icon() }}</mat-icon>
  @if (WithTooltip()) {
    <div class="sheyda-tooltip">
      <span class="tooltip-text">{{ TooltipText() }}</span>
    </div>
  }
</ng-template>
